import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { merchantResource } from '@/views/payment/merchantManage/request';
import { ACCOUNTTYPE, WeChatCOLUMNS, AlipayCOLUMNS, CUPCOLUMNS } from './../utils';
import { paymentMethodEcho2 } from '@/views/payment/merchantManage/request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  data() {
    return {
      WeChatCOLUMNS,
      AlipayCOLUMNS,
      CUPCOLUMNS,
      activeKey: 1,
      dialogVisible: false,
      ACCOUNTTYPE,
      dataForm: {
        accountType: undefined,
        accountId: undefined
      },
      accountInfo: {
        name: '',
        tableData: []
      },
      product: '',
      payment: '',
      releaseInfo: '',
      selectionRows: [],
      accountList: [],
      loading: false
    };
  },
  methods: {
    async init(product, releaseInfo, payment) {
      this.product = product;
      this.payment = payment;
      this.releaseInfo = releaseInfo;
      if (payment.payList.length != 0) {
        const {
          payList
        } = await paymentMethodEcho2({
          paymentMethods: JSON.stringify(payment),
          type: 1
        });
        this.accountInfo.tableData = payList.map(item => {
          item.checked = true;
          return item;
        });
        this.accountList = payList;
        const res = await paymentMethodEcho2({
          paymentMethods: JSON.stringify(payment),
          type: 2
        });
        this.accountList = this.accountList.concat(res.payList);
        const res2 = await paymentMethodEcho2({
          paymentMethods: JSON.stringify(payment),
          type: 3
        });
        this.accountList = this.accountList.concat(res2.payList);
        console.log(this.accountList);
      }
      // this.accountList = payment.payList.map(item => {
      //   item.id = item.merchantId;
      //   return item;
      // });
      this.dialogVisible = true;
    },
    accountTypeChange(val) {
      if (val == undefined) {
        this.accountInfo.tableData = [];
        this.accountInfo.name = '';
        return false;
      }
      const id = val == 0 ? this.releaseInfo.customerId : val == 1 ? this.product.agencyId : val == 2 ? this.product.intermediaryId : 10;
      console.log(id);
      this.dataForm.accountId = id;
      this.accountInfo.tableData.map(item => {
        const index = this.accountList.findIndex(item2 => item2.id == item.id);
        if (index != -1 && !item.checked) {
          this.accountList.splice(index, 1);
        } else if (index == -1 && item.checked) {
          this.accountList.push(item);
        }
      });
      const arr = this.accountInfo.tableData.filter(item => item.checked);
      if (arr.length != 0) {
        this.selectionRows = arr;
      }
      console.log(this.accountList);
      this.loading = true;
      this.getDataFun();
    },
    async getDataFun() {
      const {
        paymentMerchantList,
        customerName
      } = await merchantResource(Object.assign(this.dataForm, {
        type: this.activeKey
      }));
      this.accountInfo.name = customerName;
      this.accountInfo.tableData = paymentMerchantList.map(item => {
        const obj = this.accountList.find(item2 => item.id == item2.id);
        item.checked = obj ? true : false;
        return item;
      });
      this.loading = false;
    },
    tabChange(val) {
      this.accountInfo = {
        name: '',
        tableData: []
      };
      this.dataForm = {
        accountType: undefined,
        accountId: undefined
      };
      this.selectionRows = [];
      let arr = recursionCopy(this.accountList.filter(item => item.type == val));
      arr.map(item => item.checked = true);
      this.accountInfo.tableData = arr;
      this.activeKey = val;
    },
    checkboxChange(val) {
      this.accountInfo.tableData[val].checked = !this.accountInfo.tableData[val].checked;
      this.accountInfo.tableData.map((item, index) => {
        if (val != index) {
          item.checked = false;
        }
      });
      this.accountInfo.tableData.map((item, index) => {
        const index2 = this.accountList.findIndex(item2 => item2.id == item.id);
        if (index2 != -1 && !item.checked) {
          this.accountList.splice(index2, 1);
        } else if (index2 == -1 && item.checked) {
          this.accountList.push(item);
        }
      });
      console.log(this.accountList, 222);
      if (this.selectionRows.length != 0 && this.accountInfo.tableData[val].checked) {
        const index = this.accountList.findIndex(item => item.id == this.selectionRows[0].id);
        if (index != -1) {
          this.accountList.splice(index, 1);
        }
      }
    },
    handleSure() {
      if (this.accountList.length == 0) {
        return this.$message.error(this.$t('必须选择一个账户信息'));
      }
      let obj = {
        payWay: 2,
        payList: []
      };
      this.accountList.forEach(item => {
        obj.payList.push({
          merchantId: item.id
        });
      });
      this.$emit('ok', obj);
      this.$emit('cancel');
    }
  }
};